const forceReloadKey = 'forced_reload'

const testSessionStorage = () => {
  try {
    return !!window.sessionStorage
  } catch (error) {
    return false
  }
}

export const hasSessionStorage = testSessionStorage()

export const hasReloaded = () => hasSessionStorage && window.sessionStorage.getItem(forceReloadKey)

export const cleanupReload = () => {
  if (hasSessionStorage) {
    window.sessionStorage.removeItem(forceReloadKey)
  }
}

export const forceReload = () => {
  // Store in session storage that a reload happens.
  if (hasSessionStorage) {
    window.sessionStorage.setItem(forceReloadKey, 'true')
  }

  // Reload with short timeout to not go into fast reload loops.
  setTimeout(() => window.location.reload(), 1000)
}
